export const twentyFourHourTimeStringToDate = (time: string): Date => {
  const date = new Date()
  const [hours, minutes] = time.split(':')
  date.setHours(parseInt(hours))
  date.setMinutes(parseInt(minutes))
  return date
}

export const getDayOfWeekName = (day: number): string | undefined => {
  const weekday = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  return weekday[day]
}
